import React from 'react';
import { Line } from 'react-chartjs-2';

import '../../sass/components/charts/RedemptionsView.scss';

const STROKE_COLOR = '#2196F3';
const FILL_COLOR = 'rgba(33, 150, 243, 0.3)';

export default class RedemptionsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    return (
      <div className='redemptionsView'>
        <div className='chartContainer'>
          <Line
            data={{
              labels: this.props.data.keys,
              datasets: [
                {
                  label: 'Redemptions',
                  data: this.props.data.values,
                  backgroundColor: FILL_COLOR,
                  borderColor: STROKE_COLOR,
                  borderWidth: 2,
                  pointRadius: 1,
                  pointBorderWidth: 5,
                  pointHoverRadius: 7,
                  pointHitRadius: 7,
                },
              ]
            }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    stepSize: 50,
                  },
                  grid: {
                    drawBorder: false
                  }
                },
                x: {
                  grid: {
                    display: false,
                  }
                }
              },
            }}
          />
        </div>
      </div>
    )
  }

}
